import { render } from "./AceCodeEditor.vue?vue&type=template&id=1d85dd94&scoped=true"
import script from "./AceCodeEditor.vue?vue&type=script&lang=js"
export * from "./AceCodeEditor.vue?vue&type=script&lang=js"

import "./AceCodeEditor.vue?vue&type=style&index=0&id=1d85dd94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d85dd94"]])

export default __exports__